import { Component, Input, inject } from "@angular/core";
import { HssLeg } from "../models/hss-leg";
import { HssBuilderService } from "../hss-builder.service";
import { HssTimePipe } from "../pipes/hss-time.pipe";
import { HssDurationPipe } from "../pipes/hss-duration";
import { Hss } from "../models/hss";

@Component({
  selector: "app-skd-row",
  standalone: true,
  imports: [HssTimePipe, HssDurationPipe],
  templateUrl: "./skd-row.component.html",
  styleUrls: ["./skd-row.component.scss", "../hss-builder.component.scss"],
})
export class SkdRowComponent {
  @Input({ required: true }) hss!: Hss;
  @Input({ required: true }) leg!: HssLeg;
  @Input() enhanced?: boolean;
  @Input() index?: number;

  hssBuilderService = inject(HssBuilderService);
}
